import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    title: 'pages.onboarding.aiFrequency.powerful',
    subtitle: 'pages.onboarding.aiFrequency.powerfulSub',
    value: 'powerful',
  },
  {
    title: 'pages.onboarding.aiFrequency.replaceable',
    subtitle: 'pages.onboarding.aiFrequency.replaceableSub',
    value: 'replaceable',
  },
  {
    title: 'pages.onboarding.aiFrequency.excited',
    subtitle: 'pages.onboarding.aiFrequency.excitedSub',
    value: 'excited',
  },
  {
    title: 'pages.onboarding.aiFrequency.overwhelmed',
    subtitle: 'pages.onboarding.aiFrequency.overwhelmedSub',
    value: 'overwhelmed',
  },
  {
    title: 'pages.onboarding.aiFrequency.conflicted',
    subtitle: 'pages.onboarding.aiFrequency.conflictedSub',
    value: 'conflicted',
  },
  {
    title: 'pages.onboarding.aiFrequency.nothing',
    subtitle: 'pages.onboarding.aiFrequency.nothingSub',
    value: 'nothing',
  },
]

export default function AiFrequencyPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.aiFrequency.title"
      subtitle="pages.onboarding.aiFrequency.subtitle"
    />
  )
}
